type Tone = "active" | "pending" | "neutral" | "warn" | "muted";

const tones: Record<Tone, string> = {
  active:  "bg-fh-sage text-fh-green",
  pending: "bg-amber-50 text-amber-800",
  neutral: "bg-fh-sand text-fh-green-dark",
  warn:    "bg-red-50 text-red-700",
  muted:   "bg-fh-border text-fh-gray",
};

const dotColor: Record<Tone, string> = {
  active:  "bg-fh-green",
  pending: "bg-amber-500",
  neutral: "bg-fh-green-dark",
  warn:    "bg-red-500",
  muted:   "bg-fh-gray",
};

export function StatusBadge({
  label,
  tone = "neutral",
  withDot = true,
}: {
  label: string;
  tone?: Tone;
  withDot?: boolean;
}) {
  return (
    <span
      className={`inline-flex items-center gap-1.5 rounded-full px-2.5 py-1 text-[12px] font-semibold ${tones[tone]}`}
    >
      {withDot && <span className={`w-1.5 h-1.5 rounded-full ${dotColor[tone]}`} />}
      {label}
    </span>
  );
}
